module.exports = __webpack_public_path__ + "img/lang-22.5929e720.jpg";